@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-email-address-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [emailAddress]="_context.formContext.item"
                (emailAddressUpdated)="onEmailAddressUpdated($event)"
                (canceled)="onCanceled($event)"></app-email-address-form>
        </mat-tab>
    </mat-tab-group>
}
